export default __webpack_public_path__ + "static/media/Lastusedmenu.12f9df35.svg";